module.exports = "pegasus/assets/styleGroup2-google.gif";